<template>
    <div v-if="currentView === 0" class="passwordchange">
        <van-form @submit="onSubmit" ref="formRef">
            <van-cell-group inset x>
                <van-field
                    v-model="params.newPassword"
                    type="password"
                    label="新密码"
                    label-width="80rem"
                    placeholder="请输入新密码"
                    :rules="[{ required: true, message: '请输入密码' }, { validator: validatePassword, message: '密码长度为4-16位' }]"
                />
                <van-field
                    v-model="params.confirmPassword"
                    type="password"
                    label-width="80rem"
                    label="确认新密码"
                    placeholder="请再次输入新密码"
                    :rules="[{ required: true, message: '请输入密码' }, { validator: validateConfirmPassword, message: '两次密码不一致' }]"
                />
                <van-field
                    :model-value="maskedMobile"
                    label="手机号码"
                    label-width="80rem"
                    readonly
                />
                <van-field
                    v-model="params.code"
                    center
                    clearable
                    label="验证码"
                    placeholder="请输入验证码"
                    label-width="80rem"
                    :rules="[{ required: true, message: '请输入验证码' }]"
                >
                    <template #button>
                        <span v-if="remainSecond <= 0" class="auth-btn limit" @click="sendCodeAction">获取验证码</span>
                        <span v-else class="auth-btn limit fail">{{ remainSecond }}秒后获取</span>
                    </template>
                </van-field>
            </van-cell-group>
            <!-- <p class="title" @click="currentView = 1">旧密码修改</p> -->
            <div class="confirm">
                <van-button type="primary" block @click="changePassword">确认修改</van-button>
            </div>

        </van-form>
    </div>
    <div v-else-if="currentView === 1" class="passwordchange">
        <van-form @submit="onSubmitOldPassword" ref="formRef2">
            <van-cell-group inset>
                <van-field
                    v-model="params.oldPassword"
                    type="password"
                    label="旧密码"
                    placeholder="请输入旧密码"
                    :rules="[{ required: true, message: '请输入旧密码' }]"
                />
                <van-field
                    v-model="params.newPassword"
                    type="password"
                    label="新密码"
                    placeholder="请输入新密码"
                    :rules="[{ required: true, message: '请输入新密码' }, { validator: validatePassword, message: '密码长度为4-16位' }]"
                />
                <van-field
                    v-model="params.confirmPassword"
                    type="password"
                    label="确认新密码"
                    placeholder="请再次输入新密码"
                    :rules="[{ required: true, message: '请输入密码' }, { validator: validateConfirmPassword, message: '两次密码不一致' }]"
                />
            </van-cell-group>
             <p class="title" @click="currentView = 0">旧密码修改</p>
            <div class="confirm">
                <van-button type="primary" block round @click="changePasswordByOld">确认修改</van-button>
            </div>
        </van-form>
    </div>
</template>

<script setup>
import { ref, computed, reactive } from 'vue'
import { http } from '@/request/http'
import { useStore } from 'vuex'
import { showNotify } from 'vant'

const store = useStore()
const maskedMobile = computed(() => {
    const mobile = store.state.login.userInfo.mobile
    if (!mobile || mobile.length !== 11) return mobile
    return mobile.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
})

const currentView = ref(0)
const remainSecond = ref(0)
const formRef = ref(null)
const formRef2 = ref(null)

const params = reactive({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
    code: ''
})

const $emit = defineEmits(['close'])

let timer = null

const sendCodeAction = () => {
    const mobile = store.state.login.userInfo.mobile
    if (!mobile) {
        showNotify({ message: '手机号不存在' })
        return
    }
    http.post('/app-api/member/auth/send-sms-code', { mobile, scene: 4 }).then(res => {
        showNotify({ message: '验证码已发送' })
        remainSecond.value = 60
        timer = setInterval(() => {
            remainSecond.value--
            if (remainSecond.value <= 0) {
                clearInterval(timer)
            }
        }, 1000)
    }).catch(err => {
        showNotify({ message: err })
    })
}

const validatePassword = (value) => {
    return value.length >= 4 && value.length <= 16
}

const validateConfirmPassword = (value) => {
    return value === params.newPassword
}

const onSubmit = () => {
    if (params.newPassword !== params.confirmPassword) {
        showNotify({ message: '两次密码输入不一致' })
        return
    }
    changePassword()
}

const onSubmitOldPassword = () => {
    changePasswordByOld()
}

const changePassword = () => {
    http.put('/app-api/member/user/reset-password', {
        password: params.newPassword,
        code: params.code,
        mobile: store.state.login.userInfo.mobile
    }).then(res => {
        showNotify({ message: '修改成功' })
        $emit('close')
    })
}

const changePasswordByOld = () => {
    http.put('/app-api/member/user/update-password', {
        oldPassword: params.oldPassword,
        newPassword: params.newPassword
    }).then(res => {
        showNotify({ message: '修改成功' })
        $emit('close')
    })
}
</script>

<style scoped lang="scss">
.auth-btn {
    width: 80rem;
    height: 30rem;
    border-radius: 5rem;
    color: #0A84FF;
    border: 1px solid #0A84FF;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12rem;
    font-weight: 500;
    &.limit {
        width: 80rem;
    }
    &.fail {
        opacity: .7;
        cursor: not-allowed;
        background: #ccc;
        border-color: #ccc;
    }
}
.passwordchange {
    background-color: white;
    border-radius: 10rem;
    overflow: hidden;
    padding: 20rem 0;
}

.confirm {
    padding: 30rem 20rem;
    :deep(.van-button) {
        width: 80%; height: 40rem; margin: 0 auto; background-color: #000; color: white; border: none; border-radius: 0;
    }
}

.title{
    margin: 30rem 0 10rem 0; color: #0A84FF; text-align: center; 
}
</style>
